import { render, staticRenderFns } from "./StripeBridgeProducts.vue?vue&type=template&id=56ae3fa0&scoped=true"
import script from "./StripeBridgeProducts.vue?vue&type=script&lang=js"
export * from "./StripeBridgeProducts.vue?vue&type=script&lang=js"
import style0 from "./StripeBridgeProducts.vue?vue&type=style&index=0&id=56ae3fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae3fa0",
  null
  
)

export default component.exports